import { useQuery } from "@apollo/client";
import {
  DocumentType,
  OrganizationDocumentsDocument,
} from "../../../../__generated__/graphql";
import { useUser } from "../../../../contexts/UserContext/hooks/useUser";

export default function useOrganizationDocuments({
  documentType,
}: {
  documentType?: DocumentType;
}) {
  const { currentOrganization } = useUser();
  const { data, loading, error, refetch } = useQuery(
    OrganizationDocumentsDocument,
    {
      variables: {
        filter: {
          type: documentType,
        },
      },
    }
  );

  const createdDocuments = data?.documents?.filter(
    (document) => document?.ownerOrganizationId === currentOrganization?.id
  );
  const receivedDocuments = data?.documents?.filter(
    (document) => document?.ownerOrganizationId !== currentOrganization?.id
  );

  return {
    data,
    loading,
    error,
    refetch,
    createdDocuments,
    receivedDocuments,
  };
}
